module.exports = __webpack_public_path__ + "Roboto-Medium.0c23004a4832433c44d4.eot";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Roboto-Medium.eot
// module id = ../../../../../src/assets/fonts/Roboto-Medium.eot
// module chunks = main